module.exports = function (S) {
  const canvas = S.canvas;
  let isResizing = false;

  function handlePasteElement (pastedElements) {
    const filteredPastedElements = pastedElements.filter((element) => element.classList.contains('table'));

    if (filteredPastedElements.length === 1) {
      INKIVE.Table.endTableEditingMode();
      INKIVE.Table.beginTableEditingMode(filteredPastedElements[0]);
      INKIVE.Table.buildCornerGrip(filteredPastedElements[0]);
    }

    INKIVE.EditorFacade.canvas.addToSelection(filteredPastedElements);
  }

  return {
    startResize: function () {
      isResizing = true;
      INKIVE.Table.removeCornerGrip({
        removeTableSelection: false
      });
    },

    endResize: function (opts) {
      isResizing = false;

      const selectedTable = INKIVE.EditorFacade.getSelection().find(selected => selected.type === 'table');
      if (selectedTable) {
        const selectedElement = document.querySelector(`#${selectedTable.id}`);

        INKIVE.Table.updateTableRect(selectedElement);
        INKIVE.Table.buildCornerGrip(selectedElement);

        svgedit.select.getSelectorManager().requestSelector(selectedElement).resize();
      }
    },

    endEditing: function (clearSelection = true) {
      if (canvas.getMode() === 'table-edit') {
        INKIVE.Table.endTableEditingMode(clearSelection);
      }
    },

    mouseEnter: function (opts) {
      const element = opts.element.closest('.table');
      const hasSelectedElements = canvas.getSelectedElems()?.length > 0;
      const isHighlighted = element.classList.contains('highlighted');

      if (hasSelectedElements || isHighlighted) return;

      canvas.highlightElement(element);
    },

    mouseLeave: function (opts) {
      const element = opts.element.closest('.table');
      const isHighlighted = element.classList.contains('highlighted');

      if (isHighlighted) {
        canvas.clearHighlight(element);
      }
    },

    mouseDown: function (opts) {
      const mouseTarget = opts.mouse_target;
      const elementType = INKIVE.DesignFacade.getType(mouseTarget);
      const isTable = elementType === 'table';
      const selectedElements = opts.selectedElements;
      const previousElement = opts.prevElements?.[0];
      const previousElementDoubleTap = opts.prevElemDoubleTap;
      const hasGrips = !!mouseTarget.querySelector('.table-grips');
      const isTableSelected = selectedElements[0]?.closest('.table');
      const isTextEdit = canvas.getMode() === 'textedit';

      if (previousElementDoubleTap && mouseTarget !== previousElementDoubleTap) {
        return;
      }

      const isTargetSelectedElement = mouseTarget?.closest('.table') === previousElement?.closest('.table');
      const isTableEdit = canvas.getMode() === 'table-edit';
      const isEditingTableText = isTableSelected && isTextEdit;
      const isMultiSelectingElements = opts.event.shiftKey && mouseTarget?.id !== 'svgroot';

      if (!isTargetSelectedElement && (isTableEdit || isEditingTableText)) {
        this.endEditing(!isMultiSelectingElements);

        INKIVE.Table.removeCornerGrip({
          removeTableSelection: true
        });

        isMultiSelectingElements && canvas.addToSelection([mouseTarget]);

        return;
      }
      const isTargetDifferentThanPreviousElement = !previousElement || previousElement !== mouseTarget;
      const isMultipleElementsSelected = selectedElements.length > 1;
      const shouldBuildGrips = isTable && !isResizing && (!isTableSelected || !hasGrips) && selectedElements.length <= 1;

      if ((isTargetDifferentThanPreviousElement && !isTextEdit) || isMultipleElementsSelected) {
        INKIVE.Table.removeCornerGrip({
          removeTableSelection: true
        });
      }

      if (shouldBuildGrips) {
        INKIVE.Table.buildCornerGrip(mouseTarget, opts?.event);
      }
    },

    mouseUp: function (opts) {
      const mouseTarget = opts.mouse_target;
      const selector = canvas.selectorManager.findSelectorByElement(mouseTarget);
      const isTable = mouseTarget?.classList?.contains('table');
      const isMultiSelected = opts.selectedElements?.length > 1;
      selector?.toggleSelectorRect(true);

      if (isTable && !isMultiSelected) {
        INKIVE.Table.beginTableEditingMode(mouseTarget, opts?.event);
      }
    },

    selectedChanged: function (opts) {
      const pastedElements = opts?.pastedElements;

      if (pastedElements &&
        pastedElements.some(element => element.classList.contains('table'))) handlePasteElement(pastedElements);
    }
  };
};
